import React, { useState } from "react";

// ASSETS

import logoDsu from "assets/svg/LogoDsu.svg";
// STYLES
import {
  BoxWrapper,
  GirdleContainer,
} from "./GirdleStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC

import { IProps } from "./GirdleModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";


// REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS

import CustomText from "components/Atoms/CustomText/CustomText";
import { COLORS } from "constants/variables";
import { useMediaQuery } from "react-responsive";

const Girdle = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const contentDesktop = [
    t("components.girdle.content1"),
    t("components.girdle.content2"),
    t("components.girdle.content3"),
  ];
  
  const contentMobile = [
    t("components.girdle.content1"),
    t("components.girdle.content4"),
  ];
  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <GirdleContainer>
      {isMobile ? contentMobile.map((item, index) => (
        <BoxWrapper key={index} onClick={() => {
          const url = `https://www.mai.gov.ro/alegeri-locale-partiale-7-decembrie-2025/`;
          window.open(url, "_blank");
        }}>
          <CustomText text={item} type={TextType.H4} color={COLORS.AbsoluteWhite} />
        </BoxWrapper>
      )) : contentDesktop.map((item, index) => (
        <BoxWrapper key={index} onClick={() => {
          const url = `https://www.mai.gov.ro/alegeri-locale-partiale-7-decembrie-2025/`;
          window.open(url, "_blank");
        }}>
          <CustomText text={item} type={TextType.H4} color={COLORS.AbsoluteWhite} />
        </BoxWrapper>
      ))}
    </GirdleContainer>
  );
};

export default Girdle;
